var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHeartOutlineIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.487.778c.21 0 .42.021.63.042 1.242.127 2.63 1.263 2.84 3.514v.841c-.21 2.651-2.608 5.639-7.089 8.857-4.48-3.219-6.858-6.206-7.09-8.857v-.841C.968 2.083 2.378.926 3.618.82c.21-.02.421-.042.632-.042 1.388 0 2.061.505 3.008 1.662l.61.716.61-.716c.968-1.157 1.62-1.662 3.009-1.662zm0-.778c-1.789 0-2.63.778-3.619 1.935C6.88.757 6.038 0 4.25 0c-.232 0-.463.021-.716.042C2 .19.21 1.6 0 4.312v.884C.21 7.784 2.167 10.982 7.868 15c5.722-4.018 7.679-7.216 7.89-9.804v-.904c-.211-2.714-2-4.124-3.556-4.271C11.95 0 11.718 0 11.487 0z",
    fill: "#000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeartOutlineIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/heartOutlineIcon.c94e1af7.svg";
export { ForwardRef as ReactComponent };